export const APP_ROUTES = {
    HOME: '',
    WONDERS: 'maravillas',
    SHEET: 'ficha',
    MAP: 'mapa',
    DASHBOARD: 'dashboard',
    LOGIN: 'login',
    SURVEY: 'encuesta',
    CHATBOT: 'chatbot',
    LEGAL: 'aviso-legal',
    PRIVACY: 'politica-privacidad',
    COOKIES: 'politica-cookies',
    ACCOMMODATIONS: 'alojamientos',
    CONTACT: 'contacto',
    ADMIN: 'admin',
    CREATE_WONDER: 'crear-maravilla',
    GOOD_PRACTICES: 'buenas-practicas',
};

export const APP_PATHS = {
    HOME: `/${APP_ROUTES.HOME}`,
    WONDERS: `/${APP_ROUTES.WONDERS}`,
    SHEET: `/${APP_ROUTES.SHEET}`,
    MAP: `/${APP_ROUTES.MAP}`,
    DASHBOARD: `/${APP_ROUTES.DASHBOARD}`,
    LOGIN: `/${APP_ROUTES.LOGIN}`,
    SURVEY: `/${APP_ROUTES.SURVEY}`,
    CHATBOT: `/${APP_ROUTES.CHATBOT}`,
    LEGAL: `/${APP_ROUTES.LEGAL}`,
    PRIVACY: `/${APP_ROUTES.PRIVACY}`,
    COOKIES: `/${APP_ROUTES.COOKIES}`,
    ACCOMMODATIONS: `/${APP_ROUTES.ACCOMMODATIONS}`,
    CONTACT: `/${APP_ROUTES.CONTACT}`,
    ADMIN: `/${APP_ROUTES.ADMIN}`,
    CREATE_WONDER: `/${APP_ROUTES.CREATE_WONDER}`,
    GOOD_PRACTICES: `/${APP_ROUTES.GOOD_PRACTICES}`,
};
